module.exports = __webpack_public_path__ + "static/06-4c55977b8ea920f81fa0507564f7cfb6.png";